
import {interval as observableInterval } from 'rxjs';

import {timeInterval} from 'rxjs/operators';
import { MenuVisibiltyService } from '../shared/services/role-menu.service';

import { Component, ViewChild, OnInit } from '@angular/core';
import { UIChart } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import swal from 'sweetalert2';
import { AuthenticationService } from '../admin/services';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { UserNotification } from 'app/shared/models/notification';
import { NotificationService } from 'app/shared/services/notification.service';
import { trigger, state, style, transition,
    animate, group, query, stagger, keyframes
} from '@angular/animations';
import { SlideInOutAnimation } from 'app/shared/constant/animation';
import { LoadingService } from 'app/shared/services/loading.service';
import { Router } from '@angular/router';
import * as moment from 'moment';

const DEFAULT_COLORS = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099',
    '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E',
    '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC',
    '#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC']

@Component({
    templateUrl: 'app.notification.component.html',
    styleUrls: ['./app.notification.component.scss'],
    animations: [SlideInOutAnimation]
})

export class NotifcationComponent implements OnInit {
 
    corrStyleClass: string = 'corr-moderate';
     
    userInfo: any;
    notificationList: UserNotification[];
    LMSNotificationsCount;
    animationState = 'out';
    loading  = false;
    staffRole: any;
    staffName: any;
    LOSNotificationCount;
    startdate = moment().subtract(12, 'months').toDate();
    enddate = moment().toDate();
    currentDate: Date;

    constructor(
        private loadingService: LoadingService, 
       private testSrv: MenuVisibiltyService,
       private authService: AuthenticationService,
       private dashboard: DashboardService,
       private noticeService: NotificationService,
       private router: Router
    ) { }

    ngOnInit() {
        this.userInfo = this.authService.getUserInfo();
        // console.log("user login information: " + JSON.stringify(this.userInfo));
        this.staffRole = this.userInfo.staffRole;
       
        this.staffName = this.userInfo.staffName ? this.userInfo.staffName : null;
        this.authService.lockScreen$.subscribe((message) => {
         
            if (message) {
    
                this.loading =  false;
                // this.loadingService.show();
            } else {
           
            }
          });
        this.loading = true;
        // var d = new Date();
        // var a = new Date(this.currentDate.setMonth(d.getMonth() - 12));
        // this.startDate = a;
        // this.endDate = new Date();

        // this.loadingService.show();
        this.getNotifications();
        this.getLMSNotifications();
        this.getLOSNotifications(this.startdate, this.enddate);

       
        this.userInfo = this.authService.getUserInfo();
        
       
        if (this.userInfo.corrMatrixId == 1) this.corrStyleClass = 'corr-low';
         
       
        
    }
     notifcationClick(event, n) {

     }

     getLOSNotifications(startDate, endDate) {
        let data = {
            startDate: startDate,
            endDate: endDate
        }
        this.dashboard.loansOnPipeline(data)
        .subscribe((res: any)=>{
           
            this.LOSNotificationCount = res.result[0].loanCount;
        })
    }

     getLMSNotifications(){
         this.noticeService.getLMSNotificationList()
         .subscribe((res: any)=>{
            
             this.LMSNotificationsCount = res.result.loanCount;
         })
     }

     getNotifications() {
        this.loadingService.show();
        this.noticeService.getNotificationList().subscribe((res) => {
            this.loadingService.hide();
         
            this.notificationList = res;
            this.notificationList = this.notificationList.filter((n)=>{
                return n.actionUrl && 
                n.actionUrl.indexOf("credit/appraisal/credit-appraisal") !== -1;
            });
            this.animationState = 'in'
        }, (err) => {
            this.loadingService.hide();
         
        }, ()=> {
            this.loadingService.hide();
            this.loading = false;
        });
    }

    ngAfterViewInit() {
        
    }

    viewNotification(n:  UserNotification) {
       
        if ( n.actionUrl && n.actionUrl.indexOf("credit/appraisal/credit-appraisal") !== -1) {
            this.loadingService.show();
            this.router.navigate([n.actionUrl]);
            this.loadingService.hide();
        }
    }

    viewLMSNotification() {
       
            this.loadingService.show();
            this.router.navigate(['credit/loan-review-approval/appraisal']);
            this.loadingService.hide();
    }

    viewLOSNotification() {
       
        this.loadingService.show();
        this.router.navigate(['credit/appraisal/credit-appraisal']);
        this.loadingService.hide();
}
}